/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { AiChatbotRequest, ApiResult } from "../models/index";
import {
    AiChatbotRequestFromJSON,
    AiChatbotRequestToJSON,
    ApiResultFromJSON,
    ApiResultToJSON,
} from "../models/index";

export interface AiChatbotQueryRequest {
    body?: AiChatbotRequest;
}

/**
 *
 */
export class AiChatbotHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Submit a question to the Azure AI Foundry chatbot agent and return the AI response.
     */
    async aiChatbotQueryRaw(
        requestParameters: AiChatbotQueryRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/ai-chatbot/query`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: AiChatbotRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Submit a question to the Azure AI Foundry chatbot agent and return the AI response.
     */
    async aiChatbotQuery(
        requestParameters: AiChatbotQueryRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.aiChatbotQueryRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
